import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { productSizeTypes } from "../../../clients/inventoryObjects";
import utilFunctions from "../../../utilities/utilFunctions";

const ReadOnlyYieldDisplay = ({ recipe, compact }) => {
  const noYield =
    recipe.yield?.find((x) => x.isDefaultSize)?.unitOfMeasurement === null &&
    recipe.yield?.find((x) => x.isDefaultSize)?.type !==
      productSizeTypes.Arbitrary;

  if (compact) {
    if (noYield) {
      return (
        <Typography variant="body2" sx={{ color: (theme) => theme.palette.terrain[500] }}>
          No Yield Set
        </Typography>
      );
    }
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: "20px",
          backgroundColor: (theme) => theme.palette.info[600],
          borderRadius: 1,
          paddingX: 1,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: (theme) => theme.palette.pure.white,
            fontWeight: 700,
            fontSize: 10,
            lineHeight: 1,
          }}
        >
          {utilFunctions.extractRecipeYieldSizeDisplay(recipe)}
        </Typography>
      </Box>
    );
  }

  if (noYield) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "124px",
          height: "36px",
          borderRadius: 1,
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[400],
          backgroundColor: (theme) => theme.palette.pure.white,
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: (theme) => theme.palette.terrain[500] }}
        >
          No Yield Set
        </Typography>
      </Box>
    );
  }

  return (
    <Grid
      container
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", md: "space-between" },
        width: "100%",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          height: "30px",
          backgroundColor: (theme) => theme.palette.info[600],
          borderRadius: 1,
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: (theme) => theme.palette.pure.white,
            fontWeight: 700,
            fontSize: { xs: 8, md: 10 },
            lineHeight: { xs: 1, md: 1.5 },
          }}
        >
          {utilFunctions.extractRecipeYieldSizeDisplay(recipe)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ReadOnlyYieldDisplay;
